import invariant from "invariant"
// Import validation library customisations
import "yupCustom"

import { LoaderSection } from "@oj-x/ui"

import CONFIG from "configuration/environment"
import { checkLocalStorageExpiredKeys } from "services/local-storage"

import registerServiceWorkerIfEnabled from "./serviceWorker"
import "./i18n"

import { getRoot } from "./containers/root"

// Polyfill for airbnb calendar
import(/* webpackChunkName: "airbnb" */ /* webpackMode: "lazy" */ "airbnb-browser-shims")
import(/* webpackChunkName: "react-dates" */ /* webpackMode: "lazy" */ "react-dates/lib/initialize")
import(
  /* webpackChunkName: "react-app-polyfill" */ /* webpackMode: "lazy" */ "react-app-polyfill/stable"
)

// Import CSS for the app
import(
  /* webpackChunkName: "index" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/index.scss`
)
import(
  /* webpackChunkName: "base-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/base-styles.scss`
)
import(
  /* webpackChunkName: "components-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/components-styles.scss`
)
import(
  /* webpackChunkName: "containers-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/containers-styles.scss`
)
import(
  /* webpackChunkName: "scenes-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/scenes-styles.scss`
)
import(
  /* webpackChunkName: "products-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/products-styles.scss`
)
import(
  /* webpackChunkName: "features-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/features-styles.scss`
)
import(
  /* webpackChunkName: "print-styles" */ /* webpackMode: "lazy" */ `themes/${CONFIG.REACT_APP_THEME_NAME}/scss/print-styles.scss`
)

if (process.env.REACT_APP_ENABLE_AXE === "true") {
  window.axe = require("axe-core")
}

if (process.env.REACT_APP_API_MOCK === "true") {
  const setupMirage = require("./setupMirage").default

  setupMirage()
}

// verify critical environment variables are set in .env or environment
// eslint-disable-next-line import/newline-after-import
;[
  [process.env.REACT_APP_THEME_NAME, "REACT_APP_THEME_NAME"],
  [process.env.REACT_APP_TRETAIL_API_VERSION, "REACT_APP_TRETAIL_API_VERSION"],
  [process.env.REACT_APP_LOCATION_API_VERSION, "REACT_APP_LOCATION_API_VERSION"],
  [process.env.REACT_APP_PLATFORM_VERSION, "REACT_APP_PLATFORM_VERSION"],
  [process.env.REACT_APP_PRODUCTS_ORDER, "REACT_APP_PRODUCTS_ORDER"]
].forEach(([bool, key]) => {
  invariant(
    bool !== undefined,
    `This environment does not include a value for ${key},
    Please ensure the value is included in your .env file.
    See: https://openjawtech.atlassian.net/wiki/x/HYKUR for details`
  )
})

if (CONFIG.REACT_APP_DIGITAL_DATA_ENABLED) {
  const initialScript = document.getElementsByTagName("script")[0]
  const analyticsScript = document.createElement("script")
  analyticsScript.async = true

  if (CONFIG.REACT_APP_ADOBE_SCRIPT_SOURCE) {
    analyticsScript.src = CONFIG.REACT_APP_ADOBE_SCRIPT_SOURCE
    initialScript.parentNode.insertBefore(analyticsScript, initialScript)
  }

  if (CONFIG.REACT_APP_GTM_KEY) {
    analyticsScript.src = `https://www.googletagmanager.com/gtm.js?id=${CONFIG.REACT_APP_GTM_KEY}&l=digitalData`
    initialScript.parentNode.insertBefore(analyticsScript, initialScript)
  }
}

// Create the div to hold the Web App
const element = document.createElement("div")
element.id = CONFIG.REACT_APP_ROOT_DIV_ID
element.classList.add(CONFIG.REACT_APP_ROOT_DIV_CLASS)
document.body.append(element)

// Load styles and non-connected loader first (this is the smallest bundle)
const root = getRoot(CONFIG.REACT_APP_ROOT_DIV_ID)
root.render(<LoaderSection show />)

// Asyncronously load the rest of the app (for code splitting and performance)
import(
  /* webpackChunkName: "products" */
  "registerProducts"
)
  .then(() => {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "features" */ "registerFeatures")

    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "add-ons" */
      "registerAddOns"
    )
  })
  .then(() => {
    checkLocalStorageExpiredKeys()

    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "state-container" */
      /* webpackMode: "lazy" */
      "containers/web-app-loader"
    )

    // Register a service worker if it has been enabled in config.
    registerServiceWorkerIfEnabled()
  })
